import React, { useEffect, useState } from "react";

import profile from "../../asset/profile.png";
import { IoIosArrowDown } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { clearUser, selectUser } from "../../redux/authSlice";
import { FaRegUserCircle } from "react-icons/fa";
import { AiOutlineLogout } from "react-icons/ai";
import { useLogoutMutation } from "../../redux/userApi";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ChangePassword from "../Change Password/ChangePassword";
import { RiLockPasswordLine } from "react-icons/ri";
import MobileNavbar from "./MobileNavbar";
import { ReactSVG } from "react-svg";

const Navbar = () => {
  const user = useSelector(selectUser);
  const [open, setOpen] = useState(false);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [logout, { isLoading }] = useLogoutMutation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const response = await logout().unwrap();
      if (response.success) {
        toast.success("User logged out successfully.");
        dispatch(clearUser());
        navigate("/login");
      }
    } catch (err) {
      console.error("Logout error:", err);
      toast.error(err.data.message);
    }
  };

  useEffect(() => {
    const handler = (event) => {
      setTimeout(() => {
        if (!event.target.closest(".dropdown-container") && open !== null) {
          setOpen(null);
        }
      }, 1000);
    };

    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, [open]);
  return (
    <nav className="bg-white flex justify-between items-center  px-4 lg:h-[90px] h-[60px] fixed top-0 lg:left-[280px] md:left-[220px] left-0 right-0 z-50">
      <span className="text-[#151D48] lg:text-[1.5rem] text-[1.3rem]  font-bold">
        Dashboard
      </span>
      {/* <div className="flex items-center gap-2 p-3 rounded-lg  bg-[#F9FAFB]">
        <IoSearch className="text-[#00643b]" />
        <input
          type="search"
          className="text-[#737791] bg-transparent w-[20rem] outline-none"
          placeholder="Search here..."
        />
      </div> */}
      <div className="md:flex hidden lg:gap-6 gap-4 items-center">
        <NavLink
          to={`/contact-us`}
          className="bg-[#04633B1F] p-3 relative rounded-lg"
        >
          {/* <FaRegBell className="text-[#02643B] size-6" /> */}
          <ReactSVG
            src={`/icon/contactUs.svg`}
            className={`w-7 text-[#02643B]`}
          />
          <span className="w-2 h-2 rounded-full top-1 right-1 bg-[#EB5757] absolute"></span>
        </NavLink>
        <div className="flex gap-3 items-center">
          <img
            src={user?.profile ? user?.profile : profile}
            className="lg:w-14 w-12 rounded-lg"
            alt=""
          />
          <div className="flex flex-col">
            <span className="flex items-center gap-6 font-medium lg:text-[1rem] text-[.9rem] text-[#151D48] capitalize">
              {user?.name ? user?.name : "username"}
              <div className=" relative">
                <IoIosArrowDown
                  className="dropdown-container cursor-pointer"
                  onMouseDown={() => setOpen(!open)}
                />
                {open && (
                  <div
                    className="absolute right-0 z-30 mt-0 w-max p-2 origin-top-right rounded-md bg-[#fff] shadow-lg "
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className=" flex flex-col items-start gap-2 p-1 text-sm font-medium">
                      <NavLink
                        to={"/update-profile"}
                        className={`flex items-center gap-2 p-1.5 hover:bg-[#efefef] w-full rounded-lg `}
                      >
                        <FaRegUserCircle className=" size-6 text-[#00643b]" />{" "}
                        Update Profile
                      </NavLink>
                      <button
                        onClick={() => {
                          setOpen(false);
                          setIsPasswordModalOpen(true);
                        }}
                        className={`flex items-center gap-2  p-1.5 hover:bg-[#efefef] w-full rounded-lg`}
                      >
                        <RiLockPasswordLine className=" size-6 text-[#00643b]" />
                        Change Password
                      </button>

                      <p className="  rounded border-t w-full border-[#00643b]"></p>
                      <button
                        onClick={() => handleLogout()}
                        disabled={isLoading ? true : false}
                        className={`flex items-center gap-2 p-1.5 hover:bg-[#efefef] w-full rounded-lg `}
                      >
                        <AiOutlineLogout className=" size-6 text-[#00643b]" />
                        Logout
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </span>
            <span className="text-[#737791] lg:text-[14px] text-[12px] capitalize">
              {user?.role ? user?.role : "role"}
            </span>
          </div>
        </div>
      </div>
      <div className="md:hidden">
        <MobileNavbar />
      </div>
      <ChangePassword
        isOpen={isPasswordModalOpen}
        setIsOpen={setIsPasswordModalOpen}
      />
    </nav>
  );
};

export default Navbar;
